import { Box, Subtitle2, Subtitle3 } from '@csp/csp-web-ui';
import { FC } from 'react';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { ContactInformation } from '../component/ContactInformation';
import { OpeningHours } from '../component/OpeningHours';
import { TrainingMaterialsContainer } from './TrainingMaterialsContainer';

export const TechnicalSupportContainer: FC = () => {
  const supportContent = StaticContentService.getGenericBlock('webHcpTechnicalSupport', 'support');

  return (
    <>
      <Box mb={3}>
        <Subtitle2 fontWeight={700} mb={1}>
          {supportContent.header.subtitle.text}
        </Subtitle2>
        <Subtitle3>{supportContent.body.text}</Subtitle3>
      </Box>

      <ContactInformation />
      <OpeningHours />

      <TrainingMaterialsContainer />
    </>
  );
};
